<section>
  <div class="sidebar-container" [ngClass]="{'collapsed': !(isVisible$ | async)}">
    <div class="logo-container">
      <!-- Logo besar -->
      <img src="assets/logo/logo-mti.png" class="logo" [ngClass]="{'block': !(isVisible$ | async)}"
        alt="MNC Tourism Indonesia Logo"> 

      <div class="d-flex align-items-center py-2 px-2">
        <!-- Tombol close -->
        <img src="assets/icons/close.png" class="close mx-2 cursor-pointer" (click)="closeSidebar()" alt="Close Icon">
        <!-- Logo kecil -->
        <img src="assets/logo/single-logo-mti.png" class="logo-mobile" [ngClass]="{'block': isVisible$ | async}"
          alt="MNC Tourism Indonesia Small Logo">
      </div>
    </div>

    <nav class="sidebar-menu">
      <ul class="list-unstyled">
        <li *ngFor="let item of menuItems" [routerLink]="item.routeLink" [routerLinkActive]="'active'" class="menu-item"
          (click)="onMenuClick(item)">
          <i [class]="item.icon"></i>
          <span [ngClass]="{'block': !(isVisible$ | async)}">
            {{ item.label }}
          </span>
        </li>

        <hr class="line-vertical">

        <li
          class="user-info"
          (click)="onSingleClick()"
          [routerLink]="['/userprofile']"
          routerLinkActive="router-link-active"
        >
          <img [src]="itemPicture" alt="" class="rounded-circle border-light"
            style="width: 40px; height: 40px; object-fit: cover;">
          <div class="user-details">
            <span class="menu-item label-menu">{{ itemCurrentUser.name }}</span>
            <label for="admin" class="admin-label">{{ itemCurrentUser.roles }}</label>
          </div>
        </li>


      </ul>

      <ul>
        <li class="btn-logout d-flex justify-content-center align-items-center" (click)="openSignOutModal()">
          <i class="ri-logout-box-line"></i>
          <span>Sign Out</span>
        </li>
      </ul>
    </nav>

  </div>

</section>